import React from "react";
import PropTypes from "prop-types";
import "./index.less";

class Stage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCodeMirror: false
    };
  }

  styleTabs(id) {
    return this.state.currentIndex == id
      ? "weax-stage-code-tab-default weax-stage-code-tab-active"
      : "weax-stage-code-tab-default";
  }

  render() {
    const {title, width, height, children} = this.props;
    const {showCodeMirror, tabs, currentIndex} = this.state;
    return (
      <div className="weax-stage" style={{width}}>
        <div className="weax-stage-header">
          <div className="weax-stage-title">{title}</div>
          <div
            className="weax-stage-menu"
          >
            {`X`}
          </div>
        </div>
        <div className="weax-stage-body" style={{height}}>
          {children}
        </div>
      </div>
    );
  }
}

const NoElement = () => {
  return (
    <div className="weax-stage-noElement">
      <p className="weax-stage-noElement-msg">No Element Found :-)</p>
    </div>
  );
};

Stage.defaultProps = {
  title: "元素名称",
  width: "490px",
  height: "210px",
  children: <NoElement />
};

Stage.propTypes = {
  title: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.element
};

export default Stage;
